export enum AppHeaderTheme {
  Default = 'default',
  Gray = 'gray',
  Purple = 'purple',
  Orange = 'orange'
}